import { createFileRoute } from '@tanstack/react-router';
import { MyRatesPage } from '../../features/rates';

export const Route = createFileRoute('/portal/rates/mine')({ component: MyRatesPage });
